// extracted by mini-css-extract-plugin
export default {"ar-lang":"LangButton_ar-lang__dQRLT","world-icon":"LangButton_world-icon__ySFrz"};